
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 97.524c228.913 0 414.476 185.563 414.476 414.476S740.913 926.476 512 926.476 97.524 740.913 97.524 512 283.087 97.524 512 97.524zm0 73.143c-188.514 0-341.333 152.82-341.333 341.333S323.487 853.333 512 853.333 853.333 700.513 853.333 512 700.513 170.667 512 170.667zm36.571 89.697v229.864h160.866v73.143H512a36.571 36.571 0 01-36.571-36.572V260.39h73.142z","fill":"#5E7290"}})])
          )
        }
      }
    